import { useMemo } from "react";
import { IItem } from "@Front/Components/DesignSystem/Menu/MenuItem";
import { useRolePermissionContext, useRolePermissionsLoading } from "@Front/Stores/RolePermissionsStore";
import { activeOfficeStore } from "@Front/Stores/ActiveOfficeStore";
import { resolveAndFilterOfficeMenuItems } from "./officeItemsFilteringHelpers";
import { attachGuestExitBeforeNavigateToOfficeMenuLinks } from "./officeMenuAttachGuestExitBeforeNavigate";
import { useExitGuestFoldersBeforeOfficeMenuNavigation } from "./useExitGuestFoldersBeforeOfficeMenuNavigation";
import { useRolePermissionsMatrixSnapshot } from "@Front/Hooks/useRolePermissionsMatrixSnapshot";

/**
 * Candidats « Espace office » après garde-fous métier ; le filtrage matrice est fait dans le Menu via
 * `useMatrixFilteredMenuItems` + `useOfficeMenuMatrixCan` (même fichier `Header/hooks`).
 * L’office utilisé pour les droits menu est l’office métier sélectionné (comme le sélecteur), pas le sentinel GUEST_FOLDERS de la vue dossiers invités.
 */
export function useOfficeItemsFilter(officeItems: IItem[]): IItem[] {
	const permissionContext = useRolePermissionContext();
	const loadingPermissions = useRolePermissionsLoading();
	const matrix = useRolePermissionsMatrixSnapshot();
	const activeOffice = activeOfficeStore.activeOffice;
	const availableOffices = activeOfficeStore.availableOffices;
	const lastRealQuiet = activeOfficeStore.peekLastRealOfficeUidBeforeGuest();
	const exitGuestThenNavigate = useExitGuestFoldersBeforeOfficeMenuNavigation();

	return useMemo(() => {
		const filtered = resolveAndFilterOfficeMenuItems({
			permissionContext,
			loadingPermissions,
			permissionsMatrix: matrix,
			activeOffice,
			availableOffices,
			lastRealOfficeUidBeforeGuest: lastRealQuiet,
			officeItems,
		});
		return attachGuestExitBeforeNavigateToOfficeMenuLinks(filtered, exitGuestThenNavigate);
	}, [
		permissionContext,
		loadingPermissions,
		matrix,
		officeItems,
		activeOffice,
		availableOffices,
		lastRealQuiet,
		exitGuestThenNavigate,
	]);
}
